const ChatSearchIcon = ({
  className = "w-1 h-1 text-sm",
  width = 20,
  height = 20,
}) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

export default ChatSearchIcon;
